
import { FileNode, FileType } from "./FileNode";

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Class definitions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description FileNode extension meant for Url type files that will be downloaded under a .url file format
 * */
export class UrlNode extends FileNode {
    /**
     * Refer to FileNode.js for description
     * */
    getFileType() {
        return FileType.PLAIN;
    }

    /**
     * Refer to FileNode.js for description
     * */
    getContentAsBlob() {
        /* let uuid = crypto.randomUUID(); // Works for all browsers except earlier versions of safari */

        let blob = new Blob([
            "[85e9198a-e135-4dcc-8974-701f6e3458ee]\n",
            "Prop3=19,11\n",
            "[InternetShortcut]\n",
            "IDList=\n",
            `URL=${this.content}\n`
        ], {
            type: 'text/plain'
        });

        return blob;
    }
}
